module.exports = __webpack_public_path__ + "img/pgs-ara-bct.9d4bc8ca.svg";